import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HeaderMenuSeoOnlyLinksComponent } from './header-menu-seo-only-links.component';

@NgModule({
  declarations: [HeaderMenuSeoOnlyLinksComponent],
  imports: [CommonModule],
  exports: [HeaderMenuSeoOnlyLinksComponent]
})
export class HeaderMenuSeoOnlyLinksModule {}
